"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionGroups = exports.ePermissionLongIds = exports.ePermissionIds = exports.ePermPrefix = void 0;
const permission_class_1 = __importDefault(require("./permission.class"));
var ePermPrefix;
(function (ePermPrefix) {
    ePermPrefix["INTERNAL"] = "perm.internal";
    ePermPrefix["ALL"] = "perm.all";
})(ePermPrefix = exports.ePermPrefix || (exports.ePermPrefix = {}));
var ePermAction;
(function (ePermAction) {
    ePermAction["VIEW"] = "view";
    ePermAction["EDIT"] = "edit";
    ePermAction["CANCEL"] = "cancel";
    ePermAction["MANAGE"] = "manage";
    ePermAction["DELETE"] = "delete";
    ePermAction["ASSIGN"] = "assign";
    ePermAction["REACTIVATE"] = "reactivate";
    ePermAction["CREATE"] = "create";
    ePermAction["SUBMIT"] = "submit";
    ePermAction["SHARE"] = "share";
    ePermAction["BULK_UPLOAD"] = "bulk upload";
})(ePermAction || (ePermAction = {}));
var ePermScope;
(function (ePermScope) {
    ePermScope["OWN_USER"] = "my";
    ePermScope["COMPANY"] = "company";
    ePermScope["ALL"] = "all";
    ePermScope["WITHOUT_RESTRICTION"] = "withoutRestriction";
})(ePermScope || (ePermScope = {}));
var ePermItem;
(function (ePermItem) {
    ePermItem["QUOTES"] = "quotes";
    ePermItem["CERTIFICATES"] = "certificates";
    ePermItem["CLAIMS"] = "claims";
    ePermItem["CONTACTS"] = "contacts";
    ePermItem["CARRIERS"] = "carriers";
    ePermItem["BASIC_SETTINGS"] = "basicSettings";
    ePermItem["INSURANCE_SETTINGS"] = "insuranceSettings";
    ePermItem["INVOICING_SETTINGS"] = "invoicingSettings";
    ePermItem["RELEASE"] = "release";
    ePermItem["USERS"] = "users";
    ePermItem["PARTNERS"] = "partners";
    ePermItem["SANTIONS_CHECKS"] = "sanctionsChecks";
    ePermItem["TAXES"] = "taxes";
    ePermItem["INSURANCE_LICENSES"] = "insuranceLisenses";
    ePermItem["INVOICES"] = "invoices";
    ePermItem["THAMES_REFERRALS"] = "thamesReferrals";
    ePermItem["OCEAN_CARGO_REFERRALS"] = "oceanCargoReferrals";
    ePermItem["HVS_REFERRALS"] = "hvsReferrals";
    ePermItem["MTC_REFERRALS"] = "mtcReferrals";
    ePermItem["ORINOCO_REFERRALS"] = "orinocoReferrals";
    ePermItem["USER_ROLES"] = "userRoles";
    ePermItem["MASTER_POLICIES"] = "masterPolicies";
    ePermItem["INTEGRATION_SETTINGS"] = "integrationSettings";
})(ePermItem || (ePermItem = {}));
var ePermissionIds;
(function (ePermissionIds) {
    ePermissionIds[ePermissionIds["VIEW_MY_QUOTES"] = 1] = "VIEW_MY_QUOTES";
    ePermissionIds[ePermissionIds["VIEW_COMPANY_QUOTES"] = 2] = "VIEW_COMPANY_QUOTES";
    ePermissionIds[ePermissionIds["VIEW_ALL_QUOTES"] = 3] = "VIEW_ALL_QUOTES";
    ePermissionIds[ePermissionIds["EDIT_MY_QUOTES"] = 4] = "EDIT_MY_QUOTES";
    ePermissionIds[ePermissionIds["EDIT_COMPANY_QUOTES"] = 5] = "EDIT_COMPANY_QUOTES";
    ePermissionIds[ePermissionIds["EDIT_ALL_QUOTES"] = 6] = "EDIT_ALL_QUOTES";
    ePermissionIds[ePermissionIds["CREATE_QUOTES"] = 7] = "CREATE_QUOTES";
    ePermissionIds[ePermissionIds["SHARE_QUOTES"] = 8] = "SHARE_QUOTES";
    ePermissionIds[ePermissionIds["VIEW_MY_CERTIFICATES"] = 9] = "VIEW_MY_CERTIFICATES";
    ePermissionIds[ePermissionIds["VIEW_COMPANY_CERTIFICATES"] = 10] = "VIEW_COMPANY_CERTIFICATES";
    ePermissionIds[ePermissionIds["VIEW_ALL_CERTIFICATES"] = 11] = "VIEW_ALL_CERTIFICATES";
    ePermissionIds[ePermissionIds["EDIT_MY_CERTIFICATES"] = 12] = "EDIT_MY_CERTIFICATES";
    ePermissionIds[ePermissionIds["EDIT_COMPANY_CERTIFICATES"] = 13] = "EDIT_COMPANY_CERTIFICATES";
    ePermissionIds[ePermissionIds["EDIT_ALL_CERTIFICATES"] = 14] = "EDIT_ALL_CERTIFICATES";
    ePermissionIds[ePermissionIds["EDIT_CERTIFICATES_WITHOUT_RESTRICTION"] = 15] = "EDIT_CERTIFICATES_WITHOUT_RESTRICTION";
    ePermissionIds[ePermissionIds["CANCEL_MY_CERTIFICATES"] = 16] = "CANCEL_MY_CERTIFICATES";
    ePermissionIds[ePermissionIds["CANCEL_COMPANY_CERTIFICATES"] = 17] = "CANCEL_COMPANY_CERTIFICATES";
    ePermissionIds[ePermissionIds["CANCEL_ALL_CERTIFICATES"] = 18] = "CANCEL_ALL_CERTIFICATES";
    ePermissionIds[ePermissionIds["CANCEL_CERTIFICATES_WITHOUT_RESTRICTION"] = 19] = "CANCEL_CERTIFICATES_WITHOUT_RESTRICTION";
    ePermissionIds[ePermissionIds["REACTIVATE_CERTIFICATES"] = 20] = "REACTIVATE_CERTIFICATES";
    ePermissionIds[ePermissionIds["CREATE_CERTIFICATES"] = 21] = "CREATE_CERTIFICATES";
    ePermissionIds[ePermissionIds["SHARE_CERTIFICATES"] = 22] = "SHARE_CERTIFICATES";
    ePermissionIds[ePermissionIds["VIEW_MY_CLAIMS"] = 23] = "VIEW_MY_CLAIMS";
    ePermissionIds[ePermissionIds["VIEW_COMPANY_CLAIMS"] = 24] = "VIEW_COMPANY_CLAIMS";
    ePermissionIds[ePermissionIds["VIEW_ALL_CLAIMS"] = 25] = "VIEW_ALL_CLAIMS";
    ePermissionIds[ePermissionIds["EDIT_MY_CLAIMS"] = 26] = "EDIT_MY_CLAIMS";
    ePermissionIds[ePermissionIds["EDIT_COMPANY_CLAIMS"] = 27] = "EDIT_COMPANY_CLAIMS";
    ePermissionIds[ePermissionIds["EDIT_ALL_CLAIMS"] = 28] = "EDIT_ALL_CLAIMS";
    ePermissionIds[ePermissionIds["MANAGE_ALL_CLAIMS"] = 29] = "MANAGE_ALL_CLAIMS";
    ePermissionIds[ePermissionIds["SUBMIT_CLAIMS"] = 30] = "SUBMIT_CLAIMS";
    ePermissionIds[ePermissionIds["VIEW_MY_CONTACTS"] = 31] = "VIEW_MY_CONTACTS";
    ePermissionIds[ePermissionIds["VIEW_COMPANY_CONTACTS"] = 32] = "VIEW_COMPANY_CONTACTS";
    ePermissionIds[ePermissionIds["VIEW_ALL_CONTACTS"] = 33] = "VIEW_ALL_CONTACTS";
    ePermissionIds[ePermissionIds["EDIT_MY_CONTACTS"] = 34] = "EDIT_MY_CONTACTS";
    ePermissionIds[ePermissionIds["EDIT_COMPANY_CONTACTS"] = 35] = "EDIT_COMPANY_CONTACTS";
    ePermissionIds[ePermissionIds["EDIT_ALL_CONTACTS"] = 36] = "EDIT_ALL_CONTACTS";
    ePermissionIds[ePermissionIds["VIEW_MY_CARRIERS"] = 37] = "VIEW_MY_CARRIERS";
    ePermissionIds[ePermissionIds["VIEW_COMPANY_CARRIERS"] = 38] = "VIEW_COMPANY_CARRIERS";
    ePermissionIds[ePermissionIds["VIEW_ALL_CARRIERS"] = 39] = "VIEW_ALL_CARRIERS";
    ePermissionIds[ePermissionIds["EDIT_MY_CARRIERS"] = 40] = "EDIT_MY_CARRIERS";
    ePermissionIds[ePermissionIds["EDIT_COMPANY_CARRIERS"] = 41] = "EDIT_COMPANY_CARRIERS";
    ePermissionIds[ePermissionIds["EDIT_ALL_CARRIERS"] = 42] = "EDIT_ALL_CARRIERS";
    ePermissionIds[ePermissionIds["VIEW_BASIC_SETTINGS"] = 43] = "VIEW_BASIC_SETTINGS";
    ePermissionIds[ePermissionIds["EDIT_BASIC_SETTINGS"] = 44] = "EDIT_BASIC_SETTINGS";
    ePermissionIds[ePermissionIds["VIEW_INSURANCE_SETTINGS"] = 45] = "VIEW_INSURANCE_SETTINGS";
    ePermissionIds[ePermissionIds["EDIT_INSURANCE_SETTINGS"] = 46] = "EDIT_INSURANCE_SETTINGS";
    ePermissionIds[ePermissionIds["VIEW_INVOICING_SETTINGS"] = 47] = "VIEW_INVOICING_SETTINGS";
    ePermissionIds[ePermissionIds["EDIT_INVOICING_SETTINGS"] = 48] = "EDIT_INVOICING_SETTINGS";
    ePermissionIds[ePermissionIds["VIEW_RELEASE"] = 49] = "VIEW_RELEASE";
    ePermissionIds[ePermissionIds["VIEW_USERS"] = 50] = "VIEW_USERS";
    ePermissionIds[ePermissionIds["EDIT_USERS"] = 51] = "EDIT_USERS";
    ePermissionIds[ePermissionIds["DELETE_USERS"] = 52] = "DELETE_USERS";
    ePermissionIds[ePermissionIds["VIEW_PARTNERS"] = 53] = "VIEW_PARTNERS";
    ePermissionIds[ePermissionIds["EDIT_PARTNERS"] = 54] = "EDIT_PARTNERS";
    ePermissionIds[ePermissionIds["DELETE_PARTNERS"] = 55] = "DELETE_PARTNERS";
    ePermissionIds[ePermissionIds["VIEW_SANCTION_CHECKS"] = 56] = "VIEW_SANCTION_CHECKS";
    ePermissionIds[ePermissionIds["EDIT_SANCTION_CHECKS"] = 57] = "EDIT_SANCTION_CHECKS";
    ePermissionIds[ePermissionIds["VIEW_TAXES"] = 58] = "VIEW_TAXES";
    ePermissionIds[ePermissionIds["EDIT_TAXES"] = 59] = "EDIT_TAXES";
    ePermissionIds[ePermissionIds["VIEW_INSURANCE_LICENSES"] = 60] = "VIEW_INSURANCE_LICENSES";
    ePermissionIds[ePermissionIds["EDIT_INSURANCE_LICENSES"] = 61] = "EDIT_INSURANCE_LICENSES";
    ePermissionIds[ePermissionIds["VIEW_MY_INVOICES"] = 62] = "VIEW_MY_INVOICES";
    ePermissionIds[ePermissionIds["VIEW_COMPANY_INVOICES"] = 63] = "VIEW_COMPANY_INVOICES";
    ePermissionIds[ePermissionIds["VIEW_ALL_INVOICES"] = 64] = "VIEW_ALL_INVOICES";
    ePermissionIds[ePermissionIds["VIEW_THAMES_REFERRALS"] = 65] = "VIEW_THAMES_REFERRALS";
    ePermissionIds[ePermissionIds["MANAGE_THAMES_REFERRALS"] = 66] = "MANAGE_THAMES_REFERRALS";
    ePermissionIds[ePermissionIds["VIEW_OCEAN_CARGO_REFERRALS"] = 67] = "VIEW_OCEAN_CARGO_REFERRALS";
    ePermissionIds[ePermissionIds["MANAGE_OCEAN_CARGO_REFERRALS"] = 68] = "MANAGE_OCEAN_CARGO_REFERRALS";
    ePermissionIds[ePermissionIds["VIEW_HVS_REFERRALS"] = 69] = "VIEW_HVS_REFERRALS";
    ePermissionIds[ePermissionIds["MANAGE_HVS_REFERRALS"] = 70] = "MANAGE_HVS_REFERRALS";
    ePermissionIds[ePermissionIds["VIEW_MTC_REFERRALS"] = 71] = "VIEW_MTC_REFERRALS";
    ePermissionIds[ePermissionIds["MANAGE_MTC_REFERRALS"] = 72] = "MANAGE_MTC_REFERRALS";
    ePermissionIds[ePermissionIds["VIEW_ORINOCO_REFERRALS"] = 73] = "VIEW_ORINOCO_REFERRALS";
    ePermissionIds[ePermissionIds["MANAGE_ORINOCO_REFERRALS"] = 74] = "MANAGE_ORINOCO_REFERRALS";
    ePermissionIds[ePermissionIds["ASSIGN_USER_ROLES"] = 75] = "ASSIGN_USER_ROLES";
    ePermissionIds[ePermissionIds["VIEW_MASTER_POLICIES"] = 76] = "VIEW_MASTER_POLICIES";
    ePermissionIds[ePermissionIds["VIEW_INTEGRATION_SETTINGS"] = 77] = "VIEW_INTEGRATION_SETTINGS";
    ePermissionIds[ePermissionIds["MANAGE_INTEGRATION_SETTINGS"] = 78] = "MANAGE_INTEGRATION_SETTINGS";
    ePermissionIds[ePermissionIds["BULK_UPLOAD"] = 79] = "BULK_UPLOAD";
    ePermissionIds[ePermissionIds["CREATE_YUKON_CERTIFICATES"] = 80] = "CREATE_YUKON_CERTIFICATES";
})(ePermissionIds = exports.ePermissionIds || (exports.ePermissionIds = {}));
exports.ePermissionLongIds = {
    VIEW_MY_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.VIEW}.${ePermScope.OWN_USER}`,
    VIEW_COMPANY_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.VIEW}.${ePermScope.COMPANY}`,
    VIEW_ALL_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_MY_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.EDIT}.${ePermScope.OWN_USER}`,
    EDIT_COMPANY_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.EDIT}.${ePermScope.COMPANY}`,
    EDIT_ALL_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    CREATE_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.CREATE}.${ePermScope.ALL}`,
    SHARE_QUOTES: `${ePermPrefix.ALL}.${ePermItem.QUOTES}.${ePermAction.SHARE}.${ePermScope.ALL}`,
    VIEW_MY_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.VIEW}.${ePermScope.OWN_USER}`,
    VIEW_COMPANY_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.VIEW}.${ePermScope.COMPANY}`,
    VIEW_ALL_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_MY_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.EDIT}.${ePermScope.OWN_USER}`,
    EDIT_COMPANY_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.EDIT}.${ePermScope.COMPANY}`,
    EDIT_ALL_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    EDIT_CERTIFICATES_WITHOUT_RESTRICTION: `${ePermPrefix.INTERNAL}.${ePermItem.CERTIFICATES}.${ePermAction.EDIT}.${ePermScope.WITHOUT_RESTRICTION}`,
    CANCEL_MY_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.CANCEL}.${ePermScope.OWN_USER}`,
    CANCEL_COMPANY_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.CANCEL}.${ePermScope.COMPANY}`,
    CANCEL_ALL_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.CANCEL}.${ePermScope.ALL}`,
    CANCEL_CERTIFICATES_WITHOUT_RESTRICTION: `${ePermPrefix.INTERNAL}.${ePermItem.CERTIFICATES}.${ePermAction.CANCEL}.${ePermScope.WITHOUT_RESTRICTION}`,
    REACTIVATE_CERTIFICATES: `${ePermPrefix.INTERNAL}.${ePermItem.CERTIFICATES}.${ePermAction.REACTIVATE}.${ePermScope.ALL}`,
    CREATE_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.CREATE}.${ePermScope.ALL}`,
    SHARE_CERTIFICATES: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.SHARE}.${ePermScope.ALL}`,
    VIEW_MY_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.VIEW}.${ePermScope.OWN_USER}`,
    VIEW_COMPANY_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.VIEW}.${ePermScope.COMPANY}`,
    VIEW_ALL_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_MY_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.EDIT}.${ePermScope.OWN_USER}`,
    EDIT_COMPANY_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.EDIT}.${ePermScope.COMPANY}`,
    EDIT_ALL_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    MANAGE_ALL_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    SUBMIT_CLAIMS: `${ePermPrefix.ALL}.${ePermItem.CLAIMS}.${ePermAction.SUBMIT}.${ePermScope.ALL}`,
    VIEW_MY_CONTACTS: `${ePermPrefix.ALL}.${ePermItem.CONTACTS}.${ePermAction.VIEW}.${ePermScope.OWN_USER}`,
    VIEW_COMPANY_CONTACTS: `${ePermPrefix.ALL}.${ePermItem.CONTACTS}.${ePermAction.VIEW}.${ePermScope.COMPANY}`,
    VIEW_ALL_CONTACTS: `${ePermPrefix.ALL}.${ePermItem.CONTACTS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_MY_CONTACTS: `${ePermPrefix.ALL}.${ePermItem.CONTACTS}.${ePermAction.EDIT}.${ePermScope.OWN_USER}`,
    EDIT_COMPANY_CONTACTS: `${ePermPrefix.ALL}.${ePermItem.CONTACTS}.${ePermAction.EDIT}.${ePermScope.COMPANY}`,
    EDIT_ALL_CONTACTS: `${ePermPrefix.ALL}.${ePermItem.CONTACTS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_MY_CARRIERS: `${ePermPrefix.ALL}.${ePermItem.CARRIERS}.${ePermAction.VIEW}.${ePermScope.OWN_USER}`,
    VIEW_COMPANY_CARRIERS: `${ePermPrefix.ALL}.${ePermItem.CARRIERS}.${ePermAction.VIEW}.${ePermScope.COMPANY}`,
    VIEW_ALL_CARRIERS: `${ePermPrefix.ALL}.${ePermItem.CARRIERS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_MY_CARRIERS: `${ePermPrefix.ALL}.${ePermItem.CARRIERS}.${ePermAction.EDIT}.${ePermScope.OWN_USER}`,
    EDIT_COMPANY_CARRIERS: `${ePermPrefix.ALL}.${ePermItem.CARRIERS}.${ePermAction.EDIT}.${ePermScope.COMPANY}`,
    EDIT_ALL_CARRIERS: `${ePermPrefix.ALL}.${ePermItem.CARRIERS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_BASIC_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.BASIC_SETTINGS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_BASIC_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.BASIC_SETTINGS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_INSURANCE_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.INSURANCE_SETTINGS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_INSURANCE_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.INSURANCE_SETTINGS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_INVOICING_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.INVOICING_SETTINGS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_INVOICING_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.INVOICING_SETTINGS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_RELEASE: `${ePermPrefix.ALL}.${ePermItem.RELEASE}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    VIEW_USERS: `${ePermPrefix.ALL}.${ePermItem.USERS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_USERS: `${ePermPrefix.ALL}.${ePermItem.USERS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    DELETE_USERS: `${ePermPrefix.ALL}.${ePermItem.USERS}.${ePermAction.DELETE}.${ePermScope.ALL}`,
    VIEW_PARTNERS: `${ePermPrefix.ALL}.${ePermItem.PARTNERS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_PARTNERS: `${ePermPrefix.ALL}.${ePermItem.PARTNERS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    DELETE_PARTNERS: `${ePermPrefix.ALL}.${ePermItem.PARTNERS}.${ePermAction.DELETE}.${ePermScope.ALL}`,
    VIEW_SANCTION_CHECKS: `${ePermPrefix.INTERNAL}.${ePermItem.SANTIONS_CHECKS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_SANCTION_CHECKS: `${ePermPrefix.INTERNAL}.${ePermItem.SANTIONS_CHECKS}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_TAXES: `${ePermPrefix.ALL}.${ePermItem.TAXES}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_TAXES: `${ePermPrefix.INTERNAL}.${ePermItem.TAXES}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_INSURANCE_LICENSES: `${ePermPrefix.INTERNAL}.${ePermItem.INSURANCE_LICENSES}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    EDIT_INSURANCE_LICENSES: `${ePermPrefix.INTERNAL}.${ePermItem.INSURANCE_LICENSES}.${ePermAction.EDIT}.${ePermScope.ALL}`,
    VIEW_MY_INVOICES: `${ePermPrefix.ALL}.${ePermItem.INVOICES}.${ePermAction.VIEW}.${ePermScope.OWN_USER}`,
    VIEW_COMPANY_INVOICES: `${ePermPrefix.ALL}.${ePermItem.INVOICES}.${ePermAction.VIEW}.${ePermScope.COMPANY}`,
    VIEW_ALL_INVOICES: `${ePermPrefix.ALL}.${ePermItem.INVOICES}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    VIEW_THAMES_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.THAMES_REFERRALS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    MANAGE_THAMES_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.THAMES_REFERRALS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    VIEW_OCEAN_CARGO_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.OCEAN_CARGO_REFERRALS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    MANAGE_OCEAN_CARGO_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.OCEAN_CARGO_REFERRALS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    VIEW_HVS_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.HVS_REFERRALS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    MANAGE_HVS_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.HVS_REFERRALS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    VIEW_MTC_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.MTC_REFERRALS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    MANAGE_MTC_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.MTC_REFERRALS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    VIEW_ORINOCO_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.ORINOCO_REFERRALS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    MANAGE_ORINOCO_REFERRALS: `${ePermPrefix.INTERNAL}.${ePermItem.ORINOCO_REFERRALS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    ASSIGN_USER_ROLES: `${ePermPrefix.ALL}.${ePermItem.USER_ROLES}.${ePermAction.ASSIGN}.${ePermScope.ALL}`,
    VIEW_MASTER_POLICIES: `${ePermPrefix.ALL}.${ePermItem.MASTER_POLICIES}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    VIEW_INTEGRATION_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.INTEGRATION_SETTINGS}.${ePermAction.VIEW}.${ePermScope.ALL}`,
    MANAGE_INTEGRATION_SETTINGS: `${ePermPrefix.ALL}.${ePermItem.INTEGRATION_SETTINGS}.${ePermAction.MANAGE}.${ePermScope.ALL}`,
    BULK_UPLOAD: `${ePermPrefix.ALL}.${ePermItem.CERTIFICATES}.${ePermAction.BULK_UPLOAD}.${ePermScope.ALL}`,
    CREATE_YUKON_CERTIFICATES: `${ePermPrefix.INTERNAL}.${ePermItem.CERTIFICATES}.${ePermAction.CREATE}.${ePermScope.COMPANY}`
};
exports.permissionGroups = {
    contactsViewPermissions: [
        ePermissionIds.VIEW_MY_CONTACTS,
        ePermissionIds.VIEW_COMPANY_CONTACTS,
        ePermissionIds.VIEW_ALL_CONTACTS
    ],
    contactsEditPermissions: [
        ePermissionIds.EDIT_MY_CONTACTS,
        ePermissionIds.EDIT_COMPANY_CONTACTS,
        ePermissionIds.EDIT_ALL_CONTACTS
    ],
    carriersViewPermissions: [
        ePermissionIds.VIEW_MY_CARRIERS,
        ePermissionIds.VIEW_COMPANY_CARRIERS,
        ePermissionIds.VIEW_ALL_CARRIERS
    ],
    carriersEditPermissions: [
        ePermissionIds.EDIT_MY_CARRIERS,
        ePermissionIds.EDIT_COMPANY_CARRIERS,
        ePermissionIds.EDIT_ALL_CARRIERS
    ]
};
exports.default = permission_class_1.default;
//# sourceMappingURL=index.js.map